export enum SCENE {
    INIT = "init",
    MAIN = "main",
    ROOM_MANAGER = "room-manager",
    FLOOR_MARKER = "floor-marker",
}

export type WithScene = {
    scene: SCENE;
    changeScene: (scene: SCENE) => void;
};

